import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-nvidia-dark to-nvidia-dark-800 text-gray-300">
      <div className="container mx-auto px-6 py-12">
        <Link to="/" className="text-nvidia-green hover:text-nvidia-green-light mb-8 inline-block">
          ← Back to Home
        </Link>
        
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">1. Introduction</h2>
              <p className="mb-4">
                At Botrex AI, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI solutions and services. Please read this privacy policy carefully. By using our services, you consent to the practices described in this policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">2. Information We Collect</h2>
              <h3 className="text-xl font-semibold text-white mb-3">2.1 Personal Information</h3>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Name and contact information</li>
                <li>Business information</li>
                <li>Login credentials</li>
                <li>Payment information</li>
                <li>Usage data and preferences</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mb-3">2.2 AI Training Data</h3>
              <p className="mb-4">
                When using our AI services, we may collect and process data provided by you for training and improving our AI models. This data is handled with strict confidentiality and security measures.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">3. How We Use Your Information</h2>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Provide and improve our AI services</li>
                <li>Personalize your experience</li>
                <li>Process transactions</li>
                <li>Send administrative information</li>
                <li>Maintain service security</li>
                <li>Analyze and improve our services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">4. Data Security</h2>
              <p className="mb-4">
                We implement robust security measures to protect your information, including encryption, secure servers, and regular security audits. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">5. Data Sharing and Disclosure</h2>
              <p className="mb-4">
                We do not sell your personal information. We may share your information with:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Service providers who assist in our operations</li>
                <li>Professional advisors and auditors</li>
                <li>Law enforcement when required by law</li>
                <li>Business partners with your consent</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">6. Your Rights</h2>
              <p className="mb-4">You have the right to:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to data processing</li>
                <li>Data portability</li>
                <li>Withdraw consent</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">7. Updates to This Policy</h2>
              <p className="mb-4">
                We may update this Privacy Policy periodically. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">8. Contact Us</h2>
              <p className="mb-4">
                If you have questions about this Privacy Policy, please contact us at:
                <br />
                Email: privacy@botrex.ai
                <br />
                Address: [Company Address]
              </p>
            </section>

            <p className="text-sm text-gray-400 mt-8">Last Updated: [Current Date]</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
